import { useQuery } from "@tanstack/react-query";
import { type AgentSummary, getAgentOptions } from "@/api";

/**
 * The chat's agent and the agents its composer menu lists. The agent list is only the first page, most used first,
 * so an agent that isn't on it (a starred one, say) is loaded on its own: for its name, model and slash commands, and
 * in a new chat, listed first in the menu (an open chat's agent is fixed).
 */
export function useChatAgent({
  agents,
  agentUuid,
  isNewChat,
}: Readonly<{ agents: AgentSummary[] | undefined; agentUuid: string | null; isNewChat: boolean }>): {
  agent?: AgentSummary;
  menuAgents: AgentSummary[];
} {
  const listed = agents?.find((a) => a.uuid === agentUuid);
  const loaded = useQuery({
    ...getAgentOptions({ path: { agent_uuid: agentUuid ?? "" } }),
    select: (r) => r.data,
    enabled: Boolean(agentUuid) && agents !== undefined && !listed,
  });
  const page = agents ?? [];
  if (listed || !loaded.data) return { agent: listed, menuAgents: page };
  return { agent: loaded.data, menuAgents: isNewChat ? [loaded.data, ...page] : page };
}
